import { RustIcon } from "@/components/icons/skills/rust-icon";
import { PythonIcon } from "@/components/icons/skills/python-icon";
import { TypescriptIcon } from "@/components/icons/skills/typescript-icon";
import { FastAPIIcon } from "@/components/icons/skills/fast-api-icon";
import { DockerIcon } from "@/components/icons/skills/docker-icon";
import { LlmsIcon } from "@/components/icons/skills/llms-icon";
import { AwsIcon } from "@/components/icons/skills/aws-icon";
import { TerraformIcon } from "@/components/icons/skills/terraform-icon";
import { PostgresqlIcon } from "@/components/icons/skills/postgresql-icon";
import { KafkaIcon } from "@/components/icons/skills/kafka-icon";
import { BigQueryIcon } from "@/components/icons/skills/big-query-icon";
import { SnowflakeIcon } from "@/components/icons/skills/snowflake-icon";
import { TemporalIcon } from "@/components/icons/skills/temporal-icon";
import { NetSuiteIcon } from "@/components/icons/skills/netsuite-icon";
import { CeligoIcon } from "@/components/icons/skills/celigo-icon";
import { StripeIcon } from "@/components/icons/skills/stripe-icon";
import { GoogleAdsIcon } from "@/components/icons/skills/google-ads-icon";
import { MetaIcon } from "@/components/icons/skills/meta-icon";
import { OpenaiIcon } from "@/components/icons/skills/open-ai-icon";
import type { Skill } from "./types";

export const skillRows: Skill[][] = [
  [
    { icon: <RustIcon className="w-6 h-6" />, name: "Rust" },
    { icon: <PythonIcon className="w-6 h-6" />, name: "Python" },
    { icon: <TypescriptIcon className="w-6 h-6" />, name: "TypeScript" },
    { icon: <FastAPIIcon className="w-6 h-6" />, name: "FastAPI" },
    { icon: <DockerIcon className="w-6 h-6" />, name: "Docker" },
    { icon: <LlmsIcon className="w-6 h-6" />, name: "LLMs" },
  ],
  [
    { icon: <AwsIcon className="w-6 h-6" />, name: "AWS" },
    { icon: <TerraformIcon className="w-6 h-6" />, name: "Terraform" },
    { icon: <PostgresqlIcon className="w-6 h-6" />, name: "PostgreSQL" },
    { icon: <KafkaIcon className="w-6 h-6" />, name: "Kafka" },
    { icon: <BigQueryIcon className="w-6 h-6" />, name: "BigQuery" },
    { icon: <SnowflakeIcon className="w-6 h-6" />, name: "Snowflake" },
    { icon: <TemporalIcon className="w-6 h-6" />, name: "Temporal" },
  ],
  [
    { icon: <NetSuiteIcon className="w-6 h-6" />, name: "NetSuite" },
    { icon: <CeligoIcon className="w-6 h-6" />, name: "Celigo" },
    { icon: <StripeIcon className="w-6 h-6" />, name: "Stripe" },
    { icon: <GoogleAdsIcon className="w-6 h-6" />, name: "Google Ads" },
    { icon: <MetaIcon className="w-6 h-6" />, name: "Meta" },
    { icon: <OpenaiIcon className="w-6 h-6" />, name: "OpenAI API" },
  ],
];
